import { useMemo } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdmin, useAdminParams } from 'utils/helpers';
import useModal from 'ui/partials/Modal/useModal';
import { Task } from 'utils/types';
import partialConstants from 'ui/partials/utils/constants';
import { useNavigate } from 'react-router-dom';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';

import contactsConstants from '../../contact/utils/constants';
import c from '../utils/constants';

export default function useDeleteTask() {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;
  const navigate = useNavigate();
  const { isAdmin } = useAdmin();
  const {
    state: { isPreview },
  } = useAppWrapperContext();

  const link = useMemo(() => {
    if (!isAdmin && !isPreview) return `/sales/tasks`;

    return `/preview/accounts/${accountId}/users/${accountUserId}/sales/tasks`;
  }, [isAdmin, isPreview, accountId, accountUserId]);

  return useMutation({
    mutationFn: async (id: string) => {
      const api = new Api(args);

      const data = await api.delete(
        await withAcl({
          account: {
            url: `api/v1/tasks/${id}`,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/tasks/${id}`,
          },
        }),
      );

      return data;
    },
    onSuccess: (_, payload) => {
      const { pages }: any = queryClient.getQueryData([c.TASKS, c.TaskFilter]);
      if (pages[0]?.data) {
        const { dealId } = (pages[0]?.data as Task[]).find(
          (task: Task) => task._id === payload,
        ) as Task;

        if (dealId) {
          queryClient.invalidateQueries({ queryKey: [c.LOGS, dealId] });
          queryClient.invalidateQueries({
            queryKey: [c.TASKS, { ...c.TaskFilter, dealId }],
          });
        }
      }

      queryClient.invalidateQueries({ queryKey: [c.TASKS, c.TaskFilter] });
      queryClient.invalidateQueries({
        queryKey: [contactsConstants.LEADS],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      navigate(link);

      hideModal();
      toastSuccess('Successfully deleted task.');
    },
  });
}
